// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { handleOnBlurCoordinateField, handleOnPasteCoordinateField } from 'helpers/coordsConversion'
import React from 'react'
import { string } from 'prop-types'
import { Field } from 'redux-form'
import { formatDistanceOnBlur } from 'validators/common'

import {
  InputWithUnitToggle,
  LabeledInput,
} from 'components/Form'

const wrapperClasses = (
  'path-db-search-section-location path-db-search-section display-flex flex-wrap-wrap'
)

const Location = ({ idRoot, sourceForm }) => (
  <div className={wrapperClasses}>
    <Field
      className={'width-100'}
      component={LabeledInput}
      id={`${idRoot}latitude`}
      label={'Latitude'}
      name={'latitude'}
      onBlurCustom={handleOnBlurCoordinateField}
      onPasteCustom={handleOnPasteCoordinateField} />
    <Field
      className={'width-100'}
      component={LabeledInput}
      id={`${idRoot}longitude`}
      label={'Longitude'}
      name={'longitude'}
      onBlurCustom={handleOnBlurCoordinateField}
      onPasteCustom={handleOnPasteCoordinateField} />
    <InputWithUnitToggle
      convertDistance={true}
      idRoot={`${idRoot}radius`}
      label={'Search Radius'}
      nameRoot={'radius'}
      onBlurCustom = {formatDistanceOnBlur}
      sourceForm={sourceForm} />
  </div>
)

Location.propTypes = {
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default Location
